<template>
  <div>
    <v-alert color="warning" :value="proposal.disabled">
      Cette proposition a été désactivée
    </v-alert>
    <v-alert color="info" :value="true" v-if="plannedVisit">
      Une visite est prévue le
      {{ proposal.visited.dateVisite | fullDate }}
    </v-alert>
    <v-alert color="grey" :value="true" v-if="pastVisit">
      Une visite a eu lieu le
      {{ proposal.visited.dateVisite | fullDate }}
    </v-alert>
    <v-alert type="info" :value="!proposal.liked && !proposal.disliked">
      Nouvelle proposition !
    </v-alert>
    <v-alert type="success" :value="proposal.folderStatus === 'accepted'">
      Dossier accepté
    </v-alert>
    <v-alert type="info" :value="proposal.folderStatus === 'submitted'">
      Dossier déposé
    </v-alert>
    <v-alert
      :type="isDenied ? 'error' : 'info'"
      v-if="proposal.status !== 'en cours' && proposal.status != null"
      :value="proposal.status !== 'en cours'"
    >
      {{ status }}
    </v-alert>
    <v-alert type="error" :value="proposal.folderStatus === 'rejected'">
      Dossier refusé
    </v-alert>
  </div>
</template>
<script>
import moment from "moment";
import { PROJECT_STATUS } from "../../data/DefaultSettings";

export default {
  name: "ProposalStatusLines",
  props: ["proposal"],
  computed: {
    isDenied() {
      return this.proposal.status && this.proposal.status.startsWith("denied_");
    },
    status() {
      if (this.proposal.status == null) {
        return "";
      }
      return PROJECT_STATUS.filter(
        ({ value }) => value === this.proposal.status
      )[0].text;
    },
    plannedVisit() {
      return (
        !this.proposal.disabled &&
        this.proposal.visited &&
        moment(this.proposal.visited.dateVisite).isAfter(moment())
      );
    },
    pastVisit() {
      return (
        !this.proposal.disabled &&
        this.proposal.visited &&
        moment(this.proposal.visited.dateVisite).isBefore(moment())
      );
    },
    host() {
      return this.proposal._host;
    }
  }
};
</script>
